import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { IC_ExecutionStartState } from 'src/app/Interface/IC_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ICService } from 'src/app/Service/IC/IC.service';
@Component({selector:'app-ic-assignment-detail',templateUrl:'./ICAssignmentDetail.component.html',styleUrls:['./ICAssignmentDetail.component.css']})
export class ICAssignmentDetailComponent implements OnInit {
  data: any;
  loading = false;
  executingItemId?: number;
  openingExecution = false;
  assignmentId = 0;
  states: { [id: number]: IC_ExecutionStartState } = {};
  pendingResume?: IC_ExecutionStartState;
  readonly resumeQuestion = 'برای این آیتم یک اجرای نیمه‌تمام وجود دارد. آیا می‌خواهید همان اجرا را ادامه دهید؟';
  constructor(private route: ActivatedRoute, private service: ICService, private router: Router, private alert: AlertifyService) {}
  ngOnInit(): void {
    this.assignmentId = Number(this.route.snapshot.paramMap.get('id'));
    if (!Number.isInteger(this.assignmentId) || this.assignmentId <= 0) { this.alert.ErrorMessage('شناسه نامعتبر است'); return; }
    this.load();
  }
  load(): void {
    this.loading = true;
    this.service.getAssignmentDetail(this.assignmentId).pipe(finalize(() => this.loading = false)).subscribe({
      next: value => {
        this.data = value; this.states = {};
        (value.executionStates || []).forEach((state: IC_ExecutionStartState) => this.states[state.assignmentItemId] = state);
      },
      error: () => this.alert.ErrorMessage('دریافت جزئیات ناموفق بود')
    });
  }
  isReady(item: any): boolean { return !!item?.next_IC_Date && new Date(item.next_IC_Date).getTime() <= new Date().setHours(23,59,59,999); }
  state(item: any): IC_ExecutionStartState | undefined { return this.states[item.id]; }
  statusTitle(status?: string | null): string {
    return ({ IN_PROGRESS: 'نیمه‌تمام', COMPLETED: 'تکمیل‌شده، در انتظار تأیید', UNDER_REVIEW: 'در انتظار بررسی', WAITING_FOR_APPROVAL: 'در انتظار تأیید', APPROVED: 'تأییدشده' } as any)[status || ''] || status || '';
  }
  execute(item: any, manual = false): void {
    if (this.loading || this.executingItemId || this.openingExecution || this.pendingResume || !item?.active || (!manual && !this.isReady(item))) return;
    this.executingItemId = item.id;
    this.service.getExecutionStartStates(this.assignmentId, item.id).subscribe({
      next: values => {
        const state = values.find(value => value.assignmentItemId === item.id);
        if (!state) { this.executingItemId = undefined; this.alert.ErrorMessage('وضعیت اجرای این آیتم دریافت نشد. دوباره تلاش کنید.'); return; }
        this.states[item.id] = state;
        if (state.action !== 'CREATE') { this.executingItemId = undefined; this.handleExisting(state); return; }
        this.service.createExecution({ iC_Assignment_Item_ID: item.id, execution_Source: manual ? 'MANUAL' : 'SCHEDULED' })
          .pipe(finalize(() => this.executingItemId = undefined)).subscribe({
            next: result => this.router.navigate(['/ic/execution/add', result.id]),
            error: error => {
              const conflict = error?.error as IC_ExecutionStartState;
              if (error?.status === 409 && conflict?.assignmentItemId === item.id && conflict.action !== 'CREATE') {
                this.states[item.id] = conflict; this.handleExisting(conflict);
              } else this.alert.ErrorMessage(error?.error?.message || 'شروع اجرا ناموفق بود');
            }
          });
      },
      error: error => { this.executingItemId = undefined; this.alert.ErrorMessage(error?.error?.message || 'بررسی اجرای قبلی ناموفق بود؛ دوباره تلاش کنید.'); }
    });
  }
  private handleExisting(state: IC_ExecutionStartState): void {
    if (state.action === 'RESUME' && state.executionId) this.pendingResume = state;
    else if (state.action === 'VIEW' && state.executionId) {
      this.alert.ErrorMessage(`اجرای شماره ${state.executionId}: ${this.statusTitle(state.status)}؛ اجرای جدید ایجاد نشد.`);
      this.openExisting(state);
    } else this.alert.ErrorMessage(state.message || 'سوابق اجرای باز ناسازگار است؛ انتخاب خودکار انجام نشد.');
  }
  continuePrevious(): void { if (this.pendingResume && !this.executingItemId && !this.openingExecution) this.openExisting(this.pendingResume); }
  cancelResume(): void { if (!this.executingItemId && !this.openingExecution) this.pendingResume = undefined; }
  private openExisting(state: IC_ExecutionStartState): void {
    if (!state.executionId || this.openingExecution) return;
    this.openingExecution = true;
    this.service.getExecution(state.executionId).pipe(finalize(() => this.openingExecution = false)).subscribe({
      next: detail => {
        if (detail.execution.id !== state.executionId || detail.execution.iC_Assignment_Item_ID !== state.assignmentItemId || detail.execution.iC_Assignment_ID !== this.assignmentId) {
          this.alert.ErrorMessage('اجرای دریافت‌شده متعلق به این آیتم تخصیص نیست.'); return;
        }
        this.pendingResume = undefined;
        this.router.navigate(['/ic/execution/add', state.executionId]);
      },
      error: error => this.alert.ErrorMessage(error?.error?.message || 'دسترسی یا دریافت اجرای قبلی ناموفق بود.')
    });
  }
  cancel(): void { this.router.navigate(['/ic/assignment']); }
}
